import { gql, useMutation } from '@apollo/client'
import {
  MutationRentalKillArgs,
  MutationRentalKillPayload,
} from 'src/generated'

const MUTATION_RENTAL_KILL = gql`
  mutation RentalKill($input: MutationRentalKillInput!) {
    rentalKill(input: $input) {
      rental {
        ... on BookingRental {
          id
        }
        ... on FreestyleRental {
          id
        }
      }
    }
  }
`

const useRentalKillMutation = () => {
  return useMutation<
    { rentalKill: MutationRentalKillPayload },
    MutationRentalKillArgs
  >(MUTATION_RENTAL_KILL)
}

export default useRentalKillMutation
